import React from "react";

export default function SelectInput({
  name,
  label,
  required = false,
  options = [],
  placeholder = "Select...",
  value = "",
  onChange,
  error = "",
  className = "",
  disabled = false,
}) {
  return (
    <div className={className}>
      {label && (
        <label htmlFor={name} className="mb-1.5 block text-sm font-medium text-gray-700" >
          {label}
          {required && (
            <span className="ml-1 text-red-500"> * </span>
          )}
        </label>
      )}

      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`w-full rounded-lg border bg-white px-3 py-2.5 text-sm outline-none transition
          ${
            error
              ? "border-red-500 focus:border-red-500"
              : "border-gray-300 focus:border-primary-500"
          }
          ${
            disabled
              ? "cursor-not-allowed bg-gray-100 text-gray-500"
              : "text-gray-700"
          }
        `}
      >
        <option value="" disabled>
          {placeholder}
        </option>

        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {error && (
        <p className="mt-1 text-xs text-red-500"> {error} </p>
      )}
    </div>
  );
}